module.exports = __webpack_public_path__ + "img/logo_shine_medical_couleur_blanc.3577c17c.png";